Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Type of default actions supported by metrics
 *
 * @module ActionTypes
 * @internal
 */
var ActionTypes = {
  PAGE_VIEW: "pageView", // request page view track
  TRACK: "track" // request custom link track
};

exports.default = ActionTypes;